import * as React from 'react'
import { useDispatch, useSelector } from "react-redux"
import { appActions, userInfoActions } from "../actions"
import { IUserInfo } from "../types/appDataTypes"
import PrimaryButton from "../components/PrimaryButton"
import * as AppTypes from "AppTypes"
import "../components/ArtistTypeOption/artistTypeOption.scss"
import { classNames } from '../utils'
import getStepConfig from "./stepConfig"
import api from "../utils/api"
import { updateLanguageAATagging, updateAATagging } from '../utils/aatagging'
import { Card } from "@material-ui/core";
import { sanitize } from 'dompurify'

const ArtistStatus: React.FC = () => {
    const dispatch = useDispatch();
    const { userInfo, artistInfo, isCallingApi, langPack } = useSelector((state: AppTypes.ReducerState) => ({
        userInfo: state.userInfo,
        artistInfo: state.userInfo.artistInfo || {},
        isCallingApi: state.app.isCallingApi,
        langPack: state.config.langPack
    }))
    const [isError, setIsError] = React.useState(false)

    const nextStep = async () => {
        let isAllValid = true

        if (!artistInfo.artistStatus) {
            isAllValid = false
            setIsError(true)
        }

        if (isAllValid) {
            const response = await api.updateApplication(userInfo)
            if (response && response.status === 200) {
                const { nextStep } = getStepConfig()
                dispatch(appActions.gotoStep(nextStep))

                // AA Tracking
                const AALang = updateLanguageAATagging(langPack["lang"])
                updateAATagging({
                    "event_name": "generic_form_complete_step7",
                    "form_name": "UOB PoY",
                    "step_name": "established_emerging_artist",
                    "language": AALang,
                    "country": userInfo.activeCountry.toLowerCase()
                }, "other_form_step")
            }

        }
    }

    const handleChange = (artistStatus: IUserInfo["artistInfo"]["artistStatus"]) => {
        dispatch(userInfoActions.updateArtistInfo({ artistStatus }))
        setIsError(false)
    }

    return (
        <React.Fragment>
            <div className="content content--center custom-padding">
              
                <p>{langPack["establishedOrEmerging"]}</p>
                <div className="artist-type-wrapper">

                    <div
                        className={classNames({
                            "artist-type-option": true,
                            "artist-type-option--active": artistInfo.artistStatus === "established"
                        })}
                        onClick={() => handleChange("established")}
                    >{langPack["establishedCategory"]}</div>
                    <div
                        className={classNames({
                            "artist-type-option": true,
                            "artist-type-option--active": artistInfo.artistStatus === "emerging"
                        })}
                        onClick={() => handleChange("emerging")}
                    >{langPack["emergingCategory"]}</div>
                </div>

                {isError && (<p className="app-warning app-error-message">{langPack["selectOne"]}</p>)}

                <Card style={{ borderRadius: '30px', padding: "30px", textAlign: "left" }}>
                    <p className="note-font note-bold">
                        {langPack["artistStatusNoteTitle"]}
                    </p>
                    <p className="note-font">{langPack["artistStatusNoteDesc"]}</p>

                    <div className="note-footer note-list">
                        <p dangerouslySetInnerHTML={{
                            __html: sanitize(langPack["artistStatusNoteList"], {
                                ADD_ATTR: ["target"],
                            }),
                        }}/>
                    </div>
                    
                    <div className="note-footer">
                        <p dangerouslySetInnerHTML={{
                            __html: sanitize(langPack["artistStatusNoteFooter"], {
                                ADD_ATTR: ["target"],
                            }),
                        }}/>
                    </div>
                </Card>
            </div>
            <div className="action">
                {langPack["competitionDisclaimer"] &&
                <>
                    <p className="app-disclaimer">{langPack["competitionDisclaimerText"]}</p>
                    <br />
                </> 
                }
              
                <PrimaryButton
                    text={langPack["buttonNext"]}
                    onClick={nextStep}
                    disabled={isCallingApi}
                />
            </div>
        </React.Fragment>
    )
}


export default ArtistStatus
